<template src="./index.html">
</template>
<script>
	import {getdata} from './data.js' 
	export default {
		name: '',
		components: {},
		data: function() {
			return {
				headData: getdata().headData,
			};
		},
		props: {
			toseeUpdate: {
				type: Boolean,
				default: false
			},
			showpz: { 
				type: Boolean,
				default: false
			},
			tableData: {
				type: Array,
				default: [],
			},
			headobj: {
				type: Object,
				default: {},
			},
			choosecellCode:{
				type:String,
				default:""
			},
			type: {
				type: String,
				default: ""
			},
		},
		created() {},
		methods: {
			inputblur(e){
				this.$emit("inputblur",e)
			},
			zcsclick(e){
				this.$emit("zcsclick",e)
			},
			forhover(table,colum,index){
				this.$emit("forhover",table,colum,index)
			},
			
			spanmethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex === 0) {
					if (rowIndex === 0) {
						return {
							rowspan: 1,
							colspan: 4
						};
					} else if(rowIndex === 4){
						return {
							rowspan: 1,
							colspan: 4
						};
					} else if(rowIndex === 8){
						return {
							rowspan: 1,
							colspan: 4
						};
					} else if(rowIndex === 12){
						return {
							rowspan: 1,
							colspan: 4
						};
					} else{
						return {
							rowspan: 1,
							colspan: 1
						};
					}
				}else if(columnIndex === 1){
					if (rowIndex === 0) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if(rowIndex === 4){
						return {
							rowspan: 0,
							colspan: 0
						};
					}else{
						return {
							rowspan: 1,
							colspan: 1
						};
					}
				}else if(columnIndex === 2){
					if (rowIndex === 0) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if(rowIndex === 4){
						return {
							rowspan: 0,
							colspan: 0
						};
					}else{
						return {
							rowspan: 1,
							colspan: 1
						};
					}
				}else if(columnIndex === 3){
					if (rowIndex === 0) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if(rowIndex === 4){
						return {
							rowspan: 0,
							colspan: 0
						};
					}else{
						return {
							rowspan: 1,
							colspan: 1
						};
					}
				}
			},
			
		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
	@import url('../../SmallScaleVAT/index.less');
</style>
